import IMask from 'imask';
import moment from 'moment';
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const ISO_FORMAT = moment.ISO_8601;
export const ISO_HOURS_MINUTES_SECONDS_FORMAT = 'HH:mm:ss[Z]';
export const ISO_HOURS_MINUTES_FORMAT = 'HH:mm[Z]';
export const ISO_YEAR_FORMAT = 'YYYY';
export const ISO_YEAR_MONTH_FORMAT = 'YYYY-MM';
export const DEFAULT_DATE_FORMAT = {
    format: 'L',
    parseFormat: ISO_DATE_FORMAT,
};
export const DATE_FORMATS = {
    date: DEFAULT_DATE_FORMAT,
    full: { format: 'LLLL', parseFormat: ISO_FORMAT },
    fullDate: { format: 'dddd, LL', parseFormat: ISO_DATE_FORMAT },
    longDate: { format: 'LL', parseFormat: ISO_DATE_FORMAT },
    medium: { format: 'll LTS', parseFormat: ISO_FORMAT },
    mediumDate: { format: 'DD MMM YYYY', parseFormat: ISO_DATE_FORMAT },
    mediumTime: { format: 'LTS', parseFormat: ISO_HOURS_MINUTES_SECONDS_FORMAT },
    short: { format: 'L LT', parseFormat: ISO_FORMAT },
    shortDate: { format: 'L', parseFormat: ISO_DATE_FORMAT },
    shortMonth: { format: 'MM/YYYY', parseFormat: ISO_YEAR_MONTH_FORMAT },
    shortTime: { format: 'LT', parseFormat: ISO_HOURS_MINUTES_FORMAT },
    shortYear: { format: 'YYYY', parseFormat: ISO_YEAR_FORMAT },
    spinner: { format: 'dddd, MMM D, YYYY', parseFormat: ISO_DATE_FORMAT },
    timeSpinner: { format: 'dddd, MMM D, YYYY LT', parseFormat: ISO_FORMAT },
    timestamp: { format: 'L LTS', parseFormat: ISO_FORMAT },
};
function createMask(options) {
    const { type = 'date' } = options;
    const blocks = getMomentBlocks();
    const { format } = getDateFormat(type);
    const maskOptions = {
        blocks,
        format: date => {
            if (isValidDate(date)) {
                return moment(date).format(format);
            }
            // @ts-ignore
            return date.lastFormattedValue;
        },
        lazy: true,
        mask: Date,
        parse: text => {
            const date = moment(text, format).toDate();
            //@ts-ignore
            date.lastFormattedValue = text;
            return date;
        },
        pattern: getPattern(format),
    };
    return IMask.createMask(maskOptions);
}
function getDateFormat(type) {
    return DATE_FORMATS[type] || DEFAULT_DATE_FORMAT;
}
function getMomentBlocks() {
    const locale = moment.localeData();
    const enumBlock = (values) => {
        return { enum: values, mask: IMask.MaskedEnum };
    };
    const integerBlock = (min, max) => {
        return { mask: IMask.MaskedNumber, max, min, scale: 0, signed: false };
    };
    const rangeBlock = (from, to, maxLength) => {
        return { from, mask: IMask.MaskedRange, maxLength, to };
    };
    return {
        a: enumBlock(['am', 'pm']),
        A: enumBlock(['AM', 'PM']),
        d: integerBlock(0, 6),
        D: integerBlock(1, 31),
        dd: enumBlock(locale.weekdaysMin()),
        DD: rangeBlock(1, 99, 2),
        ddd: enumBlock(locale.weekdaysShort()),
        dddd: enumBlock(locale.weekdays()),
        h: integerBlock(0, 12),
        H: integerBlock(0, 23),
        hh: rangeBlock(0, 12, 2),
        HH: rangeBlock(0, 23, 2),
        M: integerBlock(1, 12),
        mm: rangeBlock(0, 59, 2),
        MM: rangeBlock(1, 12, 2),
        MMM: enumBlock(locale.monthsShort()),
        MMMM: enumBlock(locale.months()),
        s: integerBlock(0, 59),
        ss: rangeBlock(0, 59, 2),
        YY: rangeBlock(0, 99, 2),
        YYYY: rangeBlock(1900, 9999, 4),
    };
}
function getPattern(format) {
    const blockSeparator = ' ';
    const locale = moment.localeData();
    const originalBlocks = format.split(blockSeparator);
    const replacedBlocks = originalBlocks.map((block) => {
        const longDateFormat = locale.longDateFormat(block);
        if (longDateFormat) {
            return longDateFormat.replace(/\[/g, '{').replace(/\]/g, '}');
        }
        return block;
    });
    return replacedBlocks.join(blockSeparator);
}
function isMomentValid(value) {
    return value.isValid();
}
function isUTC(value) {
    return value.endsWith('Z');
}
function isValid(value, format = ISO_FORMAT) {
    return isMomentValid(toMoment(value, format));
}
function isValidDate(value) {
    return !isNaN(value) && value instanceof Date;
}
function toDate(value, format) {
    return toMomentUTC(value, format).toDate();
}
function toMoment(value, format) {
    return moment(value, format, true);
}
function toMomentUTC(value, format, strict = false) {
    return isUTC(value)
        ? moment.utc(value, format, strict)
        : moment(value, format, strict).utc();
}
export { createMask, getDateFormat, getPattern, isMomentValid, isValid, toDate, };
//# sourceMappingURL=date-utils.js.map